import { render } from "./Styleguide-FieldUsage-Custom.vue?vue&type=template&id=5a2a45df"
import script from "./Styleguide-FieldUsage-Custom.vue?vue&type=script&lang=js"
export * from "./Styleguide-FieldUsage-Custom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__